import { ReactNode } from 'react';
import { cardStyles, ACCENT_HEIGHT_PX } from '../../theme/tokens';

interface AnalyticsSurfaceCardProps {
  className?: string;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  accentColor?: string;
}

export function AnalyticsSurfaceCard({
  className = '',
  header,
  footer,
  children,
  accentColor,
}: AnalyticsSurfaceCardProps) {
  return (
    <div className={`relative overflow-hidden ${cardStyles} ${className}`}>
      {header ? <div className="border-b border-[var(--anl-border)] p-4">{header}</div> : null}
      <div className="p-4">{children}</div>
      {footer ? <div className="border-t border-[var(--anl-border)] p-4">{footer}</div> : null}
      {accentColor && (
        <div
          className="absolute bottom-0 left-0 right-0"
          style={{ height: ACCENT_HEIGHT_PX, backgroundColor: accentColor }}
        />
      )}
    </div>
  );
}
